import JobPositionTypeFields from './JobPositionTypeFields.component.tsx';

export default JobPositionTypeFields;
